const feedbackCard = {
  title: 'Feedback',
  by: 'Von:',
  phone: 'Telefon:',
  via: 'über',
  notes: 'Notizen',
  submit: 'Feedback hinzufügen',
  source: {
    CrewLink: 'CrewLink',
    QR: 'QR',
    TripCard: 'Fahrtenkarte',
  },
};

export default feedbackCard;
